// ProtectedRoute.jsx
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function ProtectedRoute() {
  const { user, ready, lastAuthError, hasToken } = useAuth();
  const location = useLocation();

  // ✅ robuste: si hasToken est une fn on l'appelle, sinon on le traite comme booléen
  const tokenExists =
    typeof hasToken === 'function'
      ? hasToken()
      : (hasToken ?? !!localStorage.getItem('prae.jwt'));

  if (!ready) {
    return (
      <div className="h-screen flex items-center justify-center">
        Chargement…
      </div>
    );
  }

  if (!tokenExists) {
    return (
      <Navigate
        to="/hello"
        replace
        state={{
          from: location,
          error: 'Veuillez vous connecter pour accéder à cette page.',
        }}
      />
    );
  }

  if (!user && (lastAuthError === 'server' || lastAuthError === 'network')) {
    return (
      <div className="h-screen flex flex-col items-center justify-center text-center px-6">
        <div className="mb-2 text-lg">Reconnexion en cours…</div>
        <div className="text-sm opacity-70">
          Impossible de vérifier la session (serveur ou réseau indisponible).
          Réessayez dans un instant.
        </div>
      </div>
    );
  }

  if (!user && lastAuthError === 'unauthorized') {
    return (
      <Navigate
        to="/hello"
        replace
        state={{
          from: location,
          error: "Votre session a expiré ou vous n'êtes pas autorisé(e).",
        }}
      />
    );
  }

  return <Outlet />;
}
